// Wire thumbnail arrows to the controlled <media-carousel> via aria-controls
function initThumbArrows(root = document) {
    root.querySelectorAll('.product-gallery__thumbnail-list-wrapper').forEach(wrapper => {
        if (wrapper.dataset.msThumbArrows === '1') return;

        const pageDots = wrapper.querySelector('page-dots.product-gallery__thumbnail-list');
        const prev = wrapper.querySelector('.thumbnail-nav--prev');
        const next = wrapper.querySelector('.thumbnail-nav--next');
        if (!pageDots || !prev || !next) return;

        const targetId = pageDots.getAttribute('aria-controls');
        const carousel = targetId && document.getElementById(targetId);
        if (!carousel) return;

        const send = (type) => carousel.dispatchEvent(new CustomEvent(type, { bubbles: false }));

        prev.addEventListener('click', (e) => { e.preventDefault(); send('control:prev'); });
        next.addEventListener('click', (e) => { e.preventDefault(); send('control:next'); });

        // Optional: disable/enable buttons based on carousel state
        const update = () => {
            try {
                const vis = carousel.visibleItems ?? [];
                const per = carousel.slidesPerPage ?? 1;
                const idx = carousel.selectedIndexAmongVisible ?? carousel.selectedIndex ?? 0;
                const max = Math.max(0, vis.length - per);
                prev.disabled = idx <= 0;
                next.disabled = idx >= max;
            } catch {}
        };
        carousel.addEventListener('carousel:select', update);
        carousel.addEventListener('carousel:change', update);
        carousel.addEventListener('carousel:settle', update);
        window.addEventListener('resize', update);
        requestAnimationFrame(update);

        wrapper.dataset.msThumbArrows = '1';
    });
}

// Boot + re-run on section lifecycle
const boot = (t = document) => initThumbArrows(t);
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
} else {
    boot();
}
document.addEventListener('shopify:section:load',    e => boot(e.target));
document.addEventListener('shopify:section:select',  e => boot(e.target));
document.addEventListener('shopify:section:reorder', e => boot(e.target));
document.addEventListener('shopify:block:select',    e => boot(e.target));
document.addEventListener('shopify:block:deselect',  e => boot(e.target));
